"use client";

import IconCheck from "@/app/(components)/generics/Icons/IconCheck";
import IconZap from "@/app/(components)/generics/Icons/IconZap";
import { creditCost } from "@/app/(components)/specifics/billing/BuyCredits/BuyCredits.logic";
import CTA from "@/app/(components)/specifics/pages/Home/components/CTA/CTA";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import { HomeCtaAction } from "@/app/types/common/HomeCtaAction";
import { Credits } from "@/app/vars/Credits";
import homeStyles from "../../Home.module.css";
import {
  HOME_ACTIVATION_STEPS,
  HOME_ACTIVATION_VARIANTS,
  HOME_PRICING_PERKS,
} from "./Pricing.logic";
import styles from "./Pricing.module.css";

export default function Pricing(props: DefaultProps) {
  const T = useT();
  const { params } = props;

  const openSignUp = () => ModalStore.getState().openSignUp(params);

  return (
    <div className={styles.container}>
      <div className={homeStyles.titles}>
        <h3 className={homeStyles.supTitle}>{T(TKey.HOME_MEIDLY_PRICING_SUP_TITLE)}</h3>
        <h2 className={homeStyles.statement}>{T(TKey.HOME_MEIDLY_PRICING_TITLE)}</h2>
      </div>

      <div className={styles.card}>
        <div className={styles.flow}>
          <button type="button" className={styles.source} onClick={openSignUp}>
            <IconZap size={18} />
            {T(TKey.HOME_MEIDLY_PRICING_FREE_BADGE).replace(
              "{{credits}}",
              String(Credits.DEFAULT_FREE_CREDITS),
            )}
          </button>

          <span className={styles.trunk} aria-hidden="true" />

          <div className={styles.connectors} aria-hidden="true">
            {HOME_ACTIVATION_STEPS.map((step) => (
              <span className={styles.connector} key={step.labelKey}>
                <span className={styles.drop} />
              </span>
            ))}
          </div>

          <ul className={styles.uses}>
            {HOME_ACTIVATION_STEPS.map((step) => (
              <li className={styles.useCell} key={step.labelKey}>
                <div className={styles.use}>
                  <span className={styles.useLabel}>
                    {T(step.labelKey).replace("{{count}}", String(HOME_ACTIVATION_VARIANTS))}
                  </span>
                  <span className={styles.useCost}>{creditCost(T, step.credits)}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.next}>
          <p className={styles.question}>
            {T(TKey.HOME_MEIDLY_PRICING_AFTER_QUESTION).replace(
              "{{credits}}",
              String(Credits.DEFAULT_FREE_CREDITS),
            )}
          </p>

          <div className={styles.after}>
            <div className={styles.priceBlock}>
              <p className={styles.price}>
                <span className={styles.priceAmount}>{`${Credits.UNIT_PRICE_EUR}€`}</span>
                <span className={styles.priceVat}>{T(TKey.HOME_MEIDLY_PRICING_VAT)}</span>
              </p>

              <p className={styles.priceFor}>
                {T(TKey.HOME_MEIDLY_PRICING_AFTER_FOR).replace(
                  "{{credits}}",
                  String(Credits.UNIT_SIZE),
                )}
              </p>
            </div>

            <ul className={styles.perks}>
              {HOME_PRICING_PERKS.map((perk) => (
                <li className={styles.perk} key={perk}>
                  <IconCheck color="var(--color-green-3)" />
                  {T(perk)}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={styles.cta}>
          <CTA
            params={params}
            min={false}
            hideIcon={true}
            action={HomeCtaAction.SIGN_UP}
            ctaKey={TKey.HOME_CTA_START_FREE}
          />
          <p className={styles.note}>{T(TKey.HOME_MEIDLY_CTA_NO_CARD)}</p>
        </div>
      </div>
    </div>
  );
}
